// extracted by mini-css-extract-plugin
export default {"content":"HomePage_content__L+Tmc","git":"HomePage_git__WZXIU","profile":"HomePage_profile__UIitx","info":"HomePage_info__oqKMc","description":"HomePage_description__CF+B0"};